import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const useGymProfessors = (gymId?: string) => {
  return useQuery({
    queryKey: ["gym-professors", gymId],
    queryFn: async () => {
      if (!gymId) return [];
      
      const { data, error } = await supabase
        .from("profiles")
        .select("id, first_name, last_name")
        .eq("role", "profesor")
        .eq("gym_id", gymId);
      
      if (error) throw error;
      
      return data?.map(prof => ({
        ...prof,
        full_name: `${prof.first_name} ${prof.last_name}`
      })) || [];
    },
    enabled: !!gymId,
  });
};
